import React, { useEffect, useState } from 'react';
import {getUsersFromOrganizationForAgenturen } from '../../api';
import CreateUser from '../../pages/CreateUser';
import DashboardNav from './DashboardNav';
import { useNavigate } from 'react-router-dom';
import AgenturMembersManagement from '../../pages/organization/AgenturMembersManagement';

function AgenturManagement({ agenturId, user }) {
  const navigate = useNavigate();
  const [showMembersManagement, setShowMembersManagement] = useState(true); // Immer Mitgliederverwaltung anzeigen
  const [agentur, setAgentur] = useState(null);
  const [mitglieder, setMitglieder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAddDialog, setShowAddDialog] = useState(false);

  // Handler für Navigation
  const handleLogout = () => {
    navigate('/');
  };
  const handleSectionChange = (section) => {
    if (section === 'dashboard') {
      navigate('/dashboard');
    } else if (section === 'agentur-dashboard') {
      navigate(`/agentur-dashboard/${agenturId}`);
    } else if (section === 'mitglieder') {
      setShowMembersManagement(true);
    } else if (section === 'leads') {
      navigate(`/agenturen/${agenturId}/leads`);
    }
  };

  // Agentur- und Mitglieder-Daten laden
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError('');
      try {
        const agenturDaten = await getUsersFromOrganizationForAgenturen(user.organization_id);
        if (agenturDaten.success && Array.isArray(agenturDaten.agenturen)) {
          // Agentur mit passender ID finden
          const found = agenturDaten.agenturen.find(a => a.agentur.id.toString() === agenturId.toString());
          if (found) {
            setAgentur(found.agentur);
            setMitglieder(found.mitglieder || []);
          } else {
            setError('Agentur nicht gefunden.');
            setAgentur(null);
            setMitglieder([]);
          }
        } else {
          setError(agenturDaten.error || 'Fehler beim Laden der Agentur.');
          setAgentur(null);
          setMitglieder([]);
        }
      } catch (err) {
        setError('Netzwerkfehler: ' + err.message);
        setAgentur(null);
        setMitglieder([]);
      } finally {
        setLoading(false);
      }
    };
    if (user && agenturId) {
      loadData();
    }
  }, [agenturId, user]);

  return (
    <>
      <DashboardNav
        activeSection="mitglieder"
        onSectionChange={handleSectionChange}
        onLogout={handleLogout}
        user={user}
        onOpenOrganizationManagement={() => setShowMembersManagement(true)}
        onOpenMembersManagement={() => setShowMembersManagement(true)}
        onViewOrganizationLeads={() => navigate(`/agenturen/${agenturId}/leads`)}
        onViewTeamLeads={() => {}}
        showOrgManagement={true}
        showMembersManagement={true}
        showOrganizationLeads={true}
      />
      <div className="agentur-management">
        {showMembersManagement ? (
          <AgenturMembersManagement user={user} agenturId={agenturId} onBack={() => navigate('/agenturen')} />
        ) : null}
      </div>
    </>
  );
}

export default AgenturManagement; 